import { Controller } from "@hotwired/stimulus"

const knownTimeWithin = (minutes, limit) => minutes > 0 && minutes <= limit

export default class extends Controller {
  static targets = ["search", "list", "row", "dateField", "mealTypeField", "filterPanel", "empty", "clearBar"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.hasSearchTarget
      ? this.searchTarget.value.toLowerCase().trim()
      : ""

    const filters = {}
    this.element
      .querySelectorAll("[data-filter-category]")
      .forEach((select) => {
        const val = select.value.toLowerCase()
        if (val) filters[select.dataset.filterCategory] = val
      })

    let visible = 0

    this.rowTargets.forEach((row) => {
      const name = row.dataset.recipeName || ""
      const tags = row.dataset.recipeTags || ""
      const time = parseInt(row.dataset.recipeTime || "0", 10)
      const difficulty = row.dataset.recipeDifficulty || ""
      const source = row.dataset.recipeSource || "personal"

      let show = true

      if (query && !name.includes(query)) show = false

      for (const [key, val] of Object.entries(filters)) {
        if (!show) break
        if (key === "source") {
          if (val === "discover") {
            if (source !== "discover") show = false
          } else if (val.startsWith("cookbook_")) {
            if (source !== val) show = false
          } else {
            // Default option (the user's personal cookbook): personal only.
            if (source !== "personal") show = false
          }
        } else if (key === "max_time") {
          if (!knownTimeWithin(time, parseInt(val, 10))) show = false
        } else if (key === "difficulty") {
          if (difficulty !== val) show = false
        } else {
          if (!tags.includes(val)) show = false
        }
      }

      // Default (no explicit source filter): show personal only, hide
      // cookbook-specific and discover. Matches the user's-own-cookbook
      // option that's selected by default.
      if (!filters.source && source !== "personal") show = false

      row.classList.toggle("hidden", !show)
      if (show) visible++
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visible > 0)
    }

    if (this.hasClearBarTarget) {
      const hasActiveFilters = query || Object.keys(filters).length > 0
      this.clearBarTarget.classList.toggle("hidden", !hasActiveFilters)
    }
  }

  toggleFilters() {
    if (this.hasFilterPanelTarget) {
      this.filterPanelTarget.classList.toggle("hidden")
    }
  }

  clear() {
    if (this.hasSearchTarget) this.searchTarget.value = ""
    this.element.querySelectorAll("[data-filter-category]").forEach((s) => (s.value = ""))
    this.filter()
  }
}
